import styled from 'styled-components';

export const Button = styled.div`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  align-items: center;
  cursor: pointer;

  .icon {
    margin-left: 8px;
  }
`;
